import * as Types from '../constants/Types';
import PopularPlace from './../models/PopularPlace';
import {PAGINATION} from '../constants/Define';

const initialState = {
    isSubmit: false,
    isFail: false,
    isGetItem: false,
    isFetchingUpdate: false,
    isFetching: false,
    dataList: [],
    pageSize: PAGINATION.pageSize,
    pageIndex: PAGINATION.pageIndex,
    totalCount: PAGINATION.totalCount,
    detail: {
        popularPlace: new PopularPlace(),
    },
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.POPULAR_PLACE_LIST_ACTION:
            return { ...state, isFetching: true, dataList: [] };
        case Types.POPULAR_PLACE_LIST_SUCCESS:
            return {
                ...state,
                isFetching: false,
                dataList: action.dataList,
                isSubmit: false,
                pageSize: action.pageSize,
                pageIndex: action.pageIndex,
                totalCount: action.totalCount,
                totalPage: Math.ceil(parseInt(action.totalCount) / parseInt(action.pageSize))
            };
        case Types.POPULAR_PLACE_DETAIL_ACTION:
            return { ...state, isFetching: true, detail: initialState.detail };
        case Types.POPULAR_PLACE_DETAIL_SUCCESS:
            return {
                ...state,
                isFetching: false,
                detail: { popularPlace: action.popularPlace, }
            };
        case Types.POPULAR_PLACE_DETAIL_FAIL:
            return { ...state, isFetching: false };

        case Types.POPULAR_PLACE_DETAIL_UPDATE_ACTION:
            return { ...state, isFetching: true };
        case Types.POPULAR_PLACE_DETAIL_CREATE_ACTION:
            return { ...state, isFetching: true };
        default:
            return state;
    }
}
